var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-container', [_c('v-card', {
    staticClass: "ma-auto card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-banner', {
    staticClass: "mr-auto ml-auto",
    attrs: {
      "align": "center"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "250"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "src": require("@/assets/partner_not_found.svg")
    }
  })], 1)], 1)], 1), _c('v-card-text', [_c('p', {
    staticClass: "text",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("Partner nicht gefunden.")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }